import withInjectedProps from '@atlassian/jira-common-util-with-injected-props/src/index.tsx';
import LegacyBreadcrumbAdapter from './component.tsx';
import LegacyApiBridge from './legacy-api-bridge/index.tsx';
import LegacyBreadcrumbConnector from './legacy-breadcrumb-connector/index.tsx';
import LegacyBreadcrumbRenderer from './legacy-breadcrumb-renderer/index.tsx';
import LegacyBreadcrumbState from './legacy-breadcrumb-state/index.tsx';

export default withInjectedProps(LegacyBreadcrumbAdapter, {
	// @ts-expect-error - Type 'FunctionComponent<Omit<PropsWithDefault, keyof AnalyticsEvents>>' is not assignable to type 'ComponentType<Props> | undefined'.
	LegacyApiBridge,
	LegacyBreadcrumbConnector,
	// @ts-expect-error - TS2322 - Type 'typeof LegacyBreadcrumbState' is not assignable to type 'ComponentType<LegacyBreadcrumbStateProviderProps> | undefined'.
	LegacyBreadcrumbState,
	LegacyBreadcrumbRenderer,
});
